export enum ServiceType {
  CartaElettronica = 'IE',
  CartaCartacea = 'ID',
}
